import { Environments, getEnvironmentFromHost } from '../api/endpoints';
import { allowedNonACEClubs } from '../shared/constants';

export const loginOnClick = (target: string = '_blank') => {
  window.open(getIdentityLoginUrl(), target);
};

export const createAccountOnClick = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  env === Environments.prod
    ? window.open(`https://app.ace.aaa.com/enterprise/identity/#/register`)
    : window.open(`https://${window.location.hostname}/enterprise/identity/${env}/#/register`);
};

export const getIdentityLoginUrl = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  return env === Environments.prod
    ? 'https://app.ace.aaa.com/enterprise/identity/#/login'
    : `https://${window.location.hostname}/enterprise/identity/${env}/#/login`;
};

export const constructAllowedUrl = (allowedClubs: string[], path: string) => {
  if (path && allowedClubs.indexOf(path.substring(1)) > -1) {
    return path;
  } else return '/';
};

export const isAllowedNonACEClub = (allowedClubs: string[], pathname: string) => {
  const length = pathname.length;
  return allowedClubs.indexOf(pathname.substring(length - 3, length)) > -1;
};

export const getNonAceClubCodeFromPath = (pathname: string) => {
  const allowedPathValues = [...allowedNonACEClubs, '']; //add emptystring for handling valid non ace clubs
  const clubCodeFromPath = pathname?.split('/')?.pop() || '';
  if (allowedPathValues.includes(clubCodeFromPath)) return clubCodeFromPath;

  return undefined;
};

export const getPlaceholder = (clubCode: string) => {
  switch (clubCode) {
    // case '001':
    //   return 'A12345678';
    case '018':
      return 'HIA123456789';
    case '065':
      //return 'A12345678 or AMO123456789';
      return 'AMO123456789';
    case '601':
      return 'NMA123456789';
    case '036':
      return 'NHA123456789';
    case '258':
      return 'VAA123456789';
    case '252':
      return 'TPA123456789';
    case '215':
      return 'PAA123456789';
    case '188':
      return 'PAA123456789';
    case '240':
      return 'RIA123456789';
    case '004':
    default:
      return 'CAA123456789';
  }
};

export const getTermsUrl = () => {
  const env = getEnvironmentFromHost(window.location.hostname);
  let termsUrl = '';

  switch (env) {
    case Environments.dev:
      termsUrl = 'https://appdev1.ace.aaa.com/payments/termsandconditions';
      break;
    case Environments.qa:
      termsUrl = 'https://appqa1.ace.aaa.com/payments/termsandconditions';
      break;
    case Environments.uat:
      termsUrl = 'https://appuat1.ace.aaa.com/payments/termsandconditions';
      break;
    default:
      termsUrl = 'https://app.ace.aaa.com/payments/termsandconditions';
      break;
  }
  return termsUrl;
};
